export default __webpack_public_path__ + "static/media/6.1ff09145.svg";